export type PlotPortfolioSubscription = {
  id: string;
  org: string;
  plot_portfolio_product: string;
  plot_portfolio_product_name: string;
  display_name: string;
  start_date: string;
  end_date: string;
  status: string;
  initial_setup_cost_credits: number;
  plot_creation_cost_credits: number;
  max_plots: number | null;
  max_hectares: number | null;
  total_plots: number;
  total_hectares: number;
  total_job_subscriptions: number;
  created_at: string;
  modified_at: string;
};

/**
 * GET /api/v1/subscriptions/plot-portfolio-subscriptions/
 */
export const GET_PLOT_PORTFOLIO_SUBSCRIPTIONS_PATH = 'subscriptions/plot-portfolio-subscriptions/';
export type GetPlotPortfolioSubscriptionsRequestQueryParams =
  | {
      org?: string;
      limit?: number;
      offset?: number;
    }
  | undefined;
export type GetPlotPortfolioSubscriptionsSuccessDto = {
  count: number;
  next: string | null;
  previous: string | null;
  results: PlotPortfolioSubscription[];
};
export type GetPlotPortfolioSubscriptionsErrorDto = Error;

/**
 * GET /api/v1/subscriptions/plot-portfolio-subscriptions/{id}/
 */
export const GET_PLOT_PORTFOLIO_SUBSCRIPTION_BY_ID_PATH = 'subscriptions/plot-portfolio-subscriptions/{id}/';
export type GetPlotPortfolioSubscriptionByIdRequestPathVariables = { id: string };
export type GetPlotPortfolioSubscriptionByIdErrorDto = Error;

/**
 * POST /api/v1/subscriptions/plot-portfolio-subscriptions/
 */
export const POST_PLOT_PORTFOLIO_SUBSCRIPTION_PATH = 'subscriptions/plot-portfolio-subscriptions/';
export type PostPlotPortfolioSubscriptionRequestBodyData = {
  org: string;
  plot_portfolio_product: string;
  display_name?: string;
  start_date: string;
  end_date: string;
  initial_setup_cost_credits?: number;
  plot_creation_cost_credits?: number;
  max_plots?: number | null;
  max_hectares?: number | null;
};
export type PostPlotPortfolioSubscriptionErrorDto = Error;

/**
 * PATCH /api/v1/subscriptions/plot-portfolio-subscriptions/{id}/
 */
export const PATCH_PLOT_PORTFOLIO_SUBSCRIPTION_PATH = 'subscriptions/plot-portfolio-subscriptions/{id}/';
export type PatchPlotPortfolioSubscriptionRequestPathVariables = { id: string };
export type PatchPlotPortfolioSubscriptionRequestBodyData = {
  display_name?: string;
  start_date?: string;
  end_date?: string;
  status?: string;
  initial_setup_cost_credits?: number;
  plot_creation_cost_credits?: number;
  max_plots?: number | null;
  max_hectares?: number | null;
};
export type PatchPlotPortfolioSubscriptionErrorDto = Error;
